import type { AppThunk } from '../typings/redux';

export const setDiscountModalVisibility =
  (payload: any): AppThunk =>
  (dispatch) => {
    try {
      dispatch({ type: 'SET_DISCOUNT_MODAL_VISIBILITY', payload });
    } catch {}
  };

export const setMessageModalVisibility =
  (payload: any): AppThunk =>
  (dispatch) => {
    try {
      dispatch({ type: 'SET_MESSAGE_MODAL_VISIBILITY', payload });
    } catch {}
  };

export const setSurveyModalVisibility =
  (payload: any): AppThunk =>
  (dispatch) => {
    try {
      dispatch({ type: 'SET_SURVEY_MODAL_VISIBILITY', payload });
    } catch {}
  };

export const setSurveyModalNPSVisibility =
  (payload: any): AppThunk =>
  (dispatch) => {
    try {
      dispatch({ type: 'SET_SURVEY_MODAL_NPS_VISIBILITY', payload });
    } catch {}
  };

export const setUseDesktopModalVisibility =
  (payload: any): AppThunk =>
  (dispatch) => {
    try {
      dispatch({ type: 'SET_USE_DESKTOP_MODAL_VISIBILITY', payload });
    } catch {}
  };
